import { EnvVariables } from "../../EnvVariables";

export const applicationApiUrl = EnvVariables.ApiUrl;
